import api from '@api/api';
import { TranslateData } from '@customTypes/Api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useTranslateForms = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (newOrder: TranslateData) => {
      return api.translateForms(newOrder);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(['forms']);
      },
    }
  );
  return { ...mutation };
};

export default useTranslateForms;
